module.exports = __webpack_public_path__ + "media/images/boxes/pds-box143-ddf598d4533ad7a67c17f74ae98d6215.png";